import { render } from "./VODAnalytics.vue?vue&type=template&id=76f454b2&scoped=true"
import script from "./VODAnalytics.vue?vue&type=script&setup=true&lang=js"
export * from "./VODAnalytics.vue?vue&type=script&setup=true&lang=js"

import "./VODAnalytics.vue?vue&type=style&index=0&id=76f454b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f454b2"],['__file',"src/views/VodDash/VODAnalytics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76f454b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76f454b2', __exports__)) {
    api.reload('76f454b2', __exports__)
  }
  
  module.hot.accept("./VODAnalytics.vue?vue&type=template&id=76f454b2&scoped=true", () => {
    api.rerender('76f454b2', render)
  })

}


export default __exports__